package ui.widget

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.StringResource
import tools.EFieldRegularBoolean
import tools.rememberString


@Composable
fun SwitchCard(
    field: EFieldRegularBoolean,
    label: StringResource,
    enabled: Boolean = true,
    modifier: Modifier = Modifier
) {
    ElevatedCard(
        enabled = enabled,
        modifier = modifier,
        onClick = { field.set(!field.state) },
        colors = CardDefaults.elevatedCardColors(
            containerColor = MaterialTheme.colorScheme.surfaceContainerHigh
        )
    ) {
        Row(modifier = Modifier.padding(horizontal = 8.dp)) {
            Text(
                text = label.rememberString(),
                modifier = Modifier.weight(1F)
                    .align(Alignment.CenterVertically)
            )
            IconicSwitch(
                checked = field.state,
                onCheckedChange = { field.set(it) },
                enabled = enabled,
                colors = SwitchDefaults.colors(
                    checkedThumbColor = MaterialTheme.colorScheme.primaryContainer,
                    checkedTrackColor = MaterialTheme.colorScheme.onPrimaryContainer
                )
            )
        }
    }
}